// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import Link from '~/components/Common/Link';

import './PressContact.scss';

export const query = graphql`
	fragment PressContactFragment on Ozk_pageContent {
		press_contact {
			heading
			full_name
			role
			phone {
				title
				href
			}
			email {
				title
				href
			}
		}
	}
`;

/**
 * @typedef PressContactInfoOptions
 * @property {string} uid CS unique id.
 * @property {string} heading
 * @property {string} full_name
 * @property {string} title
 * @property {string} role
 * @property {import('../CSTypes').CSLink} email
 * @property {import('../CSTypes').CSLink} phone
 *
 * @typedef PressContactProps
 * @property {PressContactInfoOptions} [options]
 */
/** @type {import('~/types/React').ReactFC<import('../CSTypes').ModelWithLivePreviewAttr<PressContactProps>>} */
const PressContact = ({ options, ...rest }) => {
	return (
		<div className="press-contact" style={{ marginBottom: '5rem' }}>
			<h3 className="heading" {...options.$?.heading}>
				{options.heading}
			</h3>
			<h4 className="name" {...options.$?.full_name}>
				{options.full_name}
			</h4>
			<h5 className="role" {...options.$?.role}>
				{options.role}
			</h5>
			<Link className="phone" {...options.phone.$?.href} to={options.phone.href}>
				{options.phone.title}
			</Link>
			<Link className="email" {...options.email.$?.href} to={options.email.href}>
				{options.email.title}
			</Link>
		</div>
	);
};

export default PressContact;
